import React, { memo } from 'react';
import classNames from 'classnames/bind';
import style from "./styles.pcss";
import { Preloader } from "../../../Preloader";
var cn = classNames.bind(style);
export var InitialSearchResult = /*#__PURE__*/memo(function (_ref) {
  var pending = _ref.pending,
    emptyText = _ref.emptyText;
  return /*#__PURE__*/React.createElement("li", {
    className: cn('list__item', {
      'list__item--loading': pending,
      'list__item--empty': !pending
    }),
    "data-t-id": "components-InitialSearchResult"
  }, pending ? /*#__PURE__*/React.createElement(Preloader, {
    size: "xs"
  }) : emptyText);
});